import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import es from 'vuetify/src/locale/es';

Vue.use( Vuetify );

export default new Vuetify( {
    lang: {
        locales: { es },
        current: 'es',

    },
    breakpoint: {
        thresholds: {
            xs: 480,
            sm: 1024,
            md: 1400,
            lg: 4000,

        },
        //scrollBarWidth: 14,
    },
    icons: {
        iconfont: 'mdi',

    },

    theme: {

        options: {
            customProperties: true,

        },

        dark: false,
        themes: {
            light:
            {
                primary: {
                    darken3: '#37474F',
                    darken2: '#263238',
                    darken1: '#263238',
                    base: '#364F6B',
                    lighten4: '#FFEBEE',
                    lighten5: '#FFCDD2',
                },
                secondary: '#2E45AF',
                accent: '#43dde6',
                error: '#f44336',
                warning: '#cddc39',
                info: '#00bcd4',
                success: '#8bc34a',
                border: '#DFDFDF',
                background: '#EEEEEE',
                background1: '#F8F9FA',
                background2: '#fbfbfb',
                background3: '#FFFFFF',

                buttons: '#616161',
                text: '#3E3E42',

                'text-titulo': '#3C4858',
                'text-subtitulo': '#3C4858',

                'text-gris': '#8898aa',

                'text-campo-titulo': '#727272',
                'text-campo-valor': '#3E3E42',

                'text-resaltado': '#333333',
            },
            dark: {
                border: '#2A2A32',

                background: '#33333d',
                background2: '#3f3f4b',
                background3: '#3f3f4b',

                buttons: '#FFFFFF',
                text: '#EEEEEE',

                'text-titulo': '#FFFFFF',
                'text-subtitulo': '#FFFFFF',

                'text-gris': '#999',

                'text-campo-titulo': '#C6C6C6',
                'text-campo-valor': '#FFFFFF',

                'text-resaltado': '#FFFFFF',
            }

        },
    }
} );